var map = {
	"./b-drunkdetec.jpg": "f534",
	"./b-fiftysg.jpg": "7d82",
	"./b-marypoppins.jpg": "f6fc",
	"./b-mysterieuzehorloge.jpg": "be10",
	"./b-poeperde.jpg": "7d76",
	"./b-victimsof.jpg": "4862",
	"./b-victoriaans.jpg": "2118",
	"./b-vogelboek.jpg": "7453",
	"./b-vreesmachine.jpg": "099e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a332";